/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { RequestTemplate } from '@src/app/model/RequestTemplate';

@Injectable({
  providedIn: 'root'
})
export class ActionTemplatesService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected get baseUrl() {
      return this.getAjaxPath('crm/actionTemplates');
  }
  protected cache: RequestTemplate[];
  protected typeString = 'actionTemplates';
}
